import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import useCrossWindowState from '@/hooks/domain/useCrossWindowState';
import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import LoadingLayout from '@/layouts/LoadingLayout';
import service from '@/services/index';

export type TypeformResponse = {
  name: string;
};

const TypeformRedirect = () => {
  const [, setRedirect] = useCrossWindowState<TypeformResponse | null>(
    'typeform-redirect',
    null,
  );

  const { navigate } = useWorkspaceRouter();
  const [searchParams, _] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (code && state) {
      const asyncUpdateHandler = async () => {
        const data = await service.typeform.createTypeformInfo(
          code,
          state,
          `${window.location.origin}/typeform`,
        );
        if (data) {
          setRedirect(data);
          window.close();
        } else {
          navigate('/500', {
            replace: true,
          });
        }
      };
      asyncUpdateHandler();
    }
  }, [navigate, setRedirect, searchParams]);

  return <LoadingLayout>Connecting Gorgias...</LoadingLayout>;
};

export default TypeformRedirect;
